import { createFileRoute } from "@tanstack/react-router"
import { defaultMeta } from "@/lib/seo"

export const Route = createFileRoute(`/_public/terms`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `Terms of Service`,
      description: `Review the terms for using ChicTravel trip planning and guide features.`,
      path: `/terms`,
    }),
  component: TermsPage,
})

function TermsPage() {
  return (
    <main className="max-w-3xl mx-auto px-6 py-16 space-y-8">
      <div className="space-y-3">
        <h1 className="text-4xl font-extrabold tracking-tight">
          Terms of Service
        </h1>
        <p className="text-muted-foreground">Last updated May 26, 2026</p>
      </div>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">Using ChicTravel</h2>
        <p className="text-muted-foreground leading-relaxed">
          ChicTravel helps you plan, organize, and share travel itineraries. You
          are responsible for the content you create, the collaborators you
          invite, and how you use travel suggestions.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">Travel Information</h2>
        <p className="text-muted-foreground leading-relaxed">
          AI suggestions, maps, places, schedules, and guide content may be
          incomplete or out of date. Confirm important travel details such as
          reservations, hours, safety requirements, visas, and transportation
          before you rely on them.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">Published Guides</h2>
        <p className="text-muted-foreground leading-relaxed">
          If you publish a guide, you allow ChicTravel to display it publicly
          and make it available for other travelers to view or copy.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold">Subscriptions</h2>
        <p className="text-muted-foreground leading-relaxed">
          Paid features are billed through our payment provider. Subscription
          access, renewals, cancellations, and refunds are handled according to
          the checkout and billing terms shown at purchase.
        </p>
      </section>
    </main>
  )
}
